export const QR_CODE_IMAGE_STYLE = {
  width: '15%',
  height: '15%',
  x: 'center',
  y: 'center'
};